module.exports = __webpack_public_path__ + "static/media/permas108.166fe9d7.jpg";